export default "__VITE_ASSET__CpjxiRq___"